export default __webpack_public_path__ + "static/media/introduction-light.76e926bc.svg";